import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import API from "../../apis"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  Label,
  Input,
} from "reactstrap"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"

import { Slide, toast, ToastContainer } from "react-toastify"
import { AvForm } from "availity-reactstrap-validation"
import FileDownload from "js-file-download"
const DataTableReclamation = props => {
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
  const [file, setFile] = useState(null)
  // Data Table
  const [orders, setOrders] = useState([])
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState("")
  const [selectEnseignant, setSelectEnseignant] = useState("")
  const [status, setStatus] = useState(0)
  var userAuthEnseignant = JSON.parse(
    localStorage.getItem("userAuthEnseignant")
  )
  var annee_id = userAuthEnseignant.user.annee_id
  var enseignant_id = userAuthEnseignant.user.enseignant_id
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    alwaysShowAllBtns: true,
    sizePerPage: 30,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  const addFile = e => {
    var file = e.target.files[0]
    setFile(file)
  }
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "enseignant",
      text: props.t("Enseignant"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "sujet",
      text: props.t("Titre"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "description",
      text: props.t("Description"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      formatter: cell => {
        if (!cell) return ""
        const words = cell.split(" ")
        if (words.length > 7) {
          const firstLine = words.slice(0, 7).join(" ")
          const rest = words.slice(7).join(" ")
          return (
            <>
              {firstLine} <br /> {rest}
            </>
          )
        }
        return cell
      },
    },
    {
      dataField: "Modifier",
      isDummyField: true,
      text: props.t("Modifier"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <i
            style={{ color: "cornflowerblue", cursor: "pointer" }}
            onClick={() => getById(row.id)}
            className="fas fa-edit"
          ></i>
        </div>
      ),
    },
    // {
    //   dataField: "id",
    //   isDummyField: true,
    //   text: "Téléchargement",
    //   style: { textAlign: "center" },
    //   headerStyle: (colum, colIndex) => {
    //     return { textAlign: "center" }
    //   },
    //   sort: true,
    //   // eslint-disable-next-line react/display-name
    //   formatter: (cellContent, row) => (
    //     <a
    //       onClick={() => download2(row.id, row.titre)}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       style={{ display: "flex", justifyContent: "center" }}
    //     >
    //       <i
    //         style={{ color: "#955cd5", cursor: "pointer" }}
    //         className="fas fa-file-download"
    //       ></i>
    //     </a>
    //   ),
    // },

    {
      dataField: "Suppression",
      isDummyField: true,
      text: props.t("Suppression"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <i
            style={{ color: "#ED6464", cursor: "pointer" }}
            onClick={() => toggle(row.id)}
            className="fas fa-trash-alt"
          ></i>
        </div>
      ),
    },
  ]
  const download2 = async (id, titre) => {
    try {
      // On attend la réponse avec await
      const res = await API.post(
        "avis/download",
        {
          id: id,
        },
        { responseType: "blob" } // Important pour les fichiers binaires
      )
      // On télécharge le fichier avec le nom souhaité
      FileDownload(res.data, `${titre}.pdf`)
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error)
      toast.error("❌ Échec du téléchargement", { containerId: "A" })
    }
  }
  const { SearchBar } = Search
  useEffect(async () => {
    const res = await API.post("reclamations/liste", { annee_id }).then(res => {
      setOrders(res.data.Reclamations)
    })
    setLoading(true)
  }, [])
  const toggle = id => {
    setModal(!modal)
    setId(id)
  }
  const getById = id => {
    const resE = API.post("reclamations/get_by_id", { id }).then(resE => {
      setId(resE.data.Reclamation.id)
      setTitle(resE.data.Reclamation.sujet)
      setDescription(resE.data.Reclamation.description)
    })
  }
  const toggleDelete = async () => {
    try {
      await API.post("reclamations/delete", {
        id,
        annee_id,
      })
      const resS = await API.post("reclamations/liste", {
        annee_id,
      })
      if (resS.data && resS.data.Reclamations) {
        setModal(false)
        setOrders(resS.data.Reclamations)
        setId("")
      }
    } catch (error) {
      console.error(error)
    }
  }
  const save = async () => {
    var pathFile = ""
    // if (file != null) {
    //   pathFile = file.name
    // }
    //
    // if (pathFile !== "") {
    const formData = new FormData()
    formData.append("sujet", title)
    formData.append("description", description)
    formData.append("annee_id", annee_id)
    formData.append("enseignant_id", enseignant_id)
    // formData.append("enseignant_ids", JSON.stringify(selectEnseignant.map(item => item.value)))
    // formData.append("fichier", file)
    try {
      // ATTENTION ici: await pour récupérer la réponse
      const resA = await API.post("reclamations/add", formData)

      // Vérification que resA.data existe
      if (resA?.data?.errNum === 200 || resA?.data?.errNum === "200") {
        setTitle("")
        setDescription("")
        toast.success("🔓✔️  Reclamation Enseignant ajouté Avec succès", {
          containerId: "A",
        })

        const res = await API.post("reclamations/liste", { annee_id })
        setOrders(res.data.Reclamations)
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement :", error)
      toast.error("❌ Une erreur est survenue", { containerId: "A" })
    }
    // }
  }
  const edit = async () => {
    // var pathFile = ""
    // if (file != null) {
    //   pathFile = file.name
    // }
    const formData = new FormData()
    // if (pathFile !== "") {
    //   formData.append("fichier", file)
    // }
    formData.append("enseignant_id", enseignant_id)
    formData.append("id", id)
    formData.append("sujet", title)
    formData.append("description", description)
    formData.append("annee_id", annee_id)
    // formData.append("active", status)
    // formData.append("enseignant_ids",JSON.stringify(selectEnseignant.map(item => item.value)))
    try {
      // ATTENTION ici: await pour récupérer la réponse
      const resA = await API.post("reclamations/edit", formData)
      // Vérification que resA.data existe
      if (resA?.data?.errNum === 200 || resA?.data?.errNum === "200") {
        setTitle("")
        setDescription("")
        setId("")
        toast.success("🔓✔️  Reclamation Enseignant ajouté Avec succès", {
          containerId: "A",
        })
        const res = await API.post("reclamations/liste", { annee_id })
        setOrders(res.data.Reclamations)
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement :", error)
      toast.error("❌ Une erreur est survenue", { containerId: "A" })
    }
  }
  const annuler = async () => {
    setTitle("")
    setDescription("")
    setId("")
  }

  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Fragment>
            <AvForm>
              <Form>
                <Row>
                  {/*<Col md="6">*/}
                  {/*  <div className="mb-3">*/}
                  {/*    <Label for="basicpill-firstname-input1">Fichier :</Label>*/}
                  {/*    <Input*/}
                  {/*      onChange={e => addFile(e)}*/}
                  {/*      className="form-control"*/}
                  {/*      type="file"*/}
                  {/*      id="formFile"*/}
                  {/*      accept=".pdf"*/}
                  {/*    />*/}
                  {/*  </div>*/}
                  {/*</Col>*/}
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">Sujet :</Label>
                      <Input
                        lg="3"
                        className="form-control"
                        placeholder="Titre"
                        type="text"
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Description :
                      </Label>
                      <Input
                        value={description}
                        lg="3"
                        className="form-control"
                        placeholder="Description ..."
                        type="textarea"
                        onChange={e => setDescription(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
              </Form>
              <div style={{ display: "flex", justifyContent: "center" }}>
                {id === "" && (
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={save}
                      >
                        {props.t("Confirmer")}
                      </button>
                    </div>
                  </Col>
                )}
                {id !== "" && (
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={edit}
                      >
                        {props.t("Modifier")}
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={annuler}
                      >
                        {props.t("Annuler")}
                      </button>
                    </div>
                  </Col>
                )}
              </div>
            </AvForm>
            <Row className="mt-4">
              <Col xs="12">
                <ToolkitProvider
                  keyField="id"
                  data={orders}
                  columns={Columns()}
                  search
                  bootstrap4
                >
                  {toolkitProps => (
                    <div>
                      <div>
                        <div className="mb-3 row" style={{ display: "flex" }}>
                          <div className="col-md-6 mb-3 row">
                            <div className="col-md-8 search-box-etd">
                              <div
                                className="search-box me-2 mb-2 d-inline-block"
                                style={{ width: "100%" }}
                              >
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <BootstrapTable
                        wrapperClasses="table-responsive"
                        noDataIndication={() => <NoDataIndication />}
                        striped={false}
                        bordered={false}
                        classes={"table align-middle table-nowrap"}
                        headerWrapperClasses={"table-light"}
                        hover
                        pagination={paginationFactory(pageOptions)}
                        {...toolkitProps.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
              </Col>
            </Row>
          </Fragment>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement")} ...{" "}
            </h4>
          </div>
        )}
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{ width: "100% !important", textAlign: "center !important" }}
          toggle={toggle}
          tag="h4"
        >
          {props.t("Suppression")} {props.t("d'avis enseignant")}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>{props.t("Voulez-vous supprimer cette avis ?")}</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDelete}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Oui")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Non")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableReclamation))
DataTableReclamation.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
